export const ordersByHour = [
  { hour: '06:00', заказы: 12, выполнено: 11 },
  { hour: '08:00', заказы: 48, выполнено: 45 },
  { hour: '10:00', заказы: 37, выполнено: 36 },
  { hour: '12:00', заказы: 52, выполнено: 49 },
  { hour: '14:00', заказы: 61, выполнено: 57 },
  { hour: '16:00', заказы: 74, выполнено: 69 },
  { hour: '18:00', заказы: 92, выполнено: 88 },
  { hour: '20:00', заказы: 68, выполнено: 64 },
  { hour: '22:00', заказы: 41, выполнено: 39 },
]

export const earningsByDay = [
  { day: 'Пн', заработок: 4210 },
  { day: 'Вт', заработок: 4575 },
  { day: 'Ср', заработок: 3915 },
  { day: 'Чт', заработок: 5120 },
  { day: 'Пт', заработок: 6445 },
  { day: 'Сб', заработок: 7060 },
  { day: 'Вс', заработок: 4835 },
]

export const earningsByCategory = [
  { name: 'Городские поездки', value: 20600 },
  { name: 'Аэропорт', value: 9300 },
  { name: 'Доставка', value: 4700 },
  { name: 'Межгород', value: 1560 },
]

export const topDrivers = [
  { name: 'Максат Нурыев', trips: 128, earnings: 4210, rating: 5.0 },
  { name: 'Довлет Аманов', trips: 114, earnings: 3820, rating: 4.9 },
  { name: 'Сельби Атаева', trips: 103, earnings: 3447, rating: 4.9 },
  { name: 'Мердан Ходжаев', trips: 97, earnings: 3065, rating: 4.8 },
  { name: 'Айна Реджепова', trips: 91, earnings: 2894, rating: 4.8 },
  { name: 'Бегенч Оразов', trips: 74, earnings: 2206, rating: 4.7 },
]
